import * as Sentry from "@sentry/browser";

import { Config } from "@tumeke/kerneljs";

Sentry.init({
  dsn: "https://7af29fec0afa48b39cc8b1b55ad7b024@o400209.ingest.sentry.io/5283402",
  environment: Config.SENTRY_ENV,
});
